module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "public-doctor"
  }, [_c('navbar'), _vm._v(" "), (_vm.status == 0) ? _c('div', [_c('md-progress', {
    staticClass: "md-accent",
    attrs: {
      "md-indeterminate": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.status == 404) ? _c('div', [_vm._v("\n\t\tAz oldal nem található\n\t")]) : _vm._e(), _vm._v(" "), (_vm.status == 200) ? _c('div', [_c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "row col-md-offset-3  col-md-6 between-md"
  }, [_c('div', {
    staticClass: "avatar",
    style: ({
      'background-image': 'url(' + _vm.profile.avatar + ')'
    })
  })])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row col-md-offset-3  col-md-6 between-md profile"
  }, [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.profile.name))])]), _vm._v(" "), _c('md-card-content', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "col-xs-12"
  }, [_vm._v("Adatok")]), _vm._v(" "), _c('p', {
    staticClass: "row"
  }), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Szakterület:")]), _vm._v(" " + _vm._s(_vm.profile.doctorData.speciality))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Jellemzők:")]), _vm._v(" " + _vm._s(_vm.profile.doctorData.specification))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Weboldal:")]), _vm._v(" " + _vm._s(_vm.profile.doctorData.website))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Facebook oldal:")]), _vm._v(" " + _vm._s(_vm.profile.doctorData.facebookPageUrl))]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "col-xs-12"
  }, [_vm._v("Bemutatkozás")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.profile.doctorData.introduction) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), (_vm.profile.doctorData.consultingConfig) ? _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "col-xs-12"
  }, [_vm._v("Rendelési időpontok")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.profile.doctorData.consultingConfig) + "\n\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h3', {
    staticClass: "col-xs-12"
  }, [_vm._v("Kapcsolati adatok")]), _vm._v(" "), (_vm.profile.doctorData.contact.length > 0) ? _c('div', _vm._l((_vm.profile.doctorData.contact), function(contact) {
    return _c('p', [_vm._v(_vm._s(contact.name) + ": " + _vm._s(contact.value))])
  })) : _c('div', [_vm._v("\n\t\t\t\t\t\t\t\tNincs megadva\n\t\t\t\t\t\t\t")])])])], 1)], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4eb63352!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublicDoctorView.vue
// module id = 419
// module chunks = 2